/**
 * Hook for marking all notifications as read
 */

import { useState, useCallback } from 'react'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../contexts/auth-context'

export function useMarkAllRead() {
  const { user } = useAuth()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const markAllRead = useCallback(async () => {
    if (!user?.id) {
      setError(new Error('User not authenticated'))
      return
    }

    try {
      setLoading(true)
      const { error: updateError } = await supabase
        .from('notifications')
        .update({ is_read: true })
        .eq('user_id', user.id)
        .eq('is_read', false)

      if (updateError) throw updateError
      setError(null)
    } catch (err) {
      console.error('Failed to mark all notifications as read:', err)
      setError(err instanceof Error ? err : new Error('Failed to mark all as read'))
    } finally {
      setLoading(false)
    }
  }, [user?.id])

  return {
    markAllRead,
    loading,
    error
  }
}
